// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"0b5b0aa6c4b7141429c1","258":"9109cf513ef59194bd6b"}[chunkId] + ".js");